import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'react-bootstrap';

interface Props {
  expanded: boolean;
  withText?: boolean;
  showText?: string;
  hideText?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ShowHideButton = ({
  expanded,
  withText = true,
  showText = 'Show',
  hideText = 'Hide',
  onClick,
  disabled,
}: Props) => {
  return (
    <Button
      className='text-end'
      variant='link'
      data-testid='show-btn'
      style={{ whiteSpace: 'nowrap', paddingRight: withText ? '0' : undefined }}
      onClick={onClick}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={expanded ? faAngleDoubleUp : faAngleDoubleDown} />
      {withText ? (expanded ? ` ${hideText}` : ` ${showText}`) : ''}
    </Button>
  );
};

export default ShowHideButton;
